<template>
  <div>
    <v-row v-if="!addressFormVisible">
      <v-col>
        <component
          :is="findPropertyQuestion.AnswerControlType"
          :question="findPropertyQuestion"
          @toggleAddressFormVisible="(value) => (addressFormVisible = value)"
        ></component>
      </v-col>
    </v-row>

    <template v-if="addressFormVisible">
      <div class="margin-address-form">
        <v-row
          v-for="(item, index) in otherAddressQuestions"
          :key="index"
          class="mt-0 mb-2"
        >
          <v-col>
            <component
              :is="item.AnswerControlType"
              :question="item"
              @tryAgain="tryAgain"
            ></component>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
import InputFindPropertyBase from "@/components/Inputs/InputFindPropertyBase";
import InputBase from "@/components/Inputs/InputBase";
import LayoutAddressMixin from "@/Mixins/LayoutAddressMixin";
import { setAddressFormVisibility } from "@/common/addresses";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "LayoutAddressSearchBase",
  mixins: [LayoutAddressMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    addressFormVisible: false,
  }),
  components: {
    InputFindPropertyBase,
    InputBase,
    HomeBaseLabel,
  },
  methods: {
    tryAgain() {
      this.addressFormVisible = false;
    },
  },
  mounted() {
    this.addressFormVisible = setAddressFormVisibility(
      this.findPropertyQuestion,
      this.otherAddressQuestions
    );
  },
};
</script>

<style lang="scss" scoped>
.margin-address-form {
  margin: -12px 0 20px 0;
}
</style>
